<template>
  <div>
    <v-col cols="12" sm="12" md="12">
      <div class="d-flex justify-end" v-if="is_admin">
        <v-btn 
          color="brand onBrand--text"
          dark
          small
          class="mt-0"
          style="border-radius:8px;margin-top:-15px"
          @click="videoDialog = true"
        >
        <v-icon left>mdi-youtube</v-icon>
        Watch Tutorial
        </v-btn>
      </div>
      <v-card class="box">
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong>
              Quiz Dashboard
            </strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-row justify="center">
          <v-btn class="button" @click="questionbank = true; response = false; scheduling = false; viewqb = false">Question
            Bank</v-btn>
          <v-btn class="button" @click="scheduling = true; questionbank = false; response = false; viewqb = false">Quiz
            Scheduling</v-btn>
          <v-btn class="button" @click="response = true; scheduling = false; questionbank = false; viewqb = false">Quiz
            Response</v-btn>
          <v-btn class="button" @click="questionbank = false; scheduling = false; response = false; viewqb = true">View Question
            Bank</v-btn>
        </v-row>
      </v-card>
      <question-bank v-if="questionbank == true"></question-bank>
      <quiz-scheduling v-if="scheduling == true"></quiz-scheduling>
      <quiz-response v-if="response == true"></quiz-response>
      <view-question-bank v-if="viewqb == true"></view-question-bank>
    </v-col>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Ouiz Dashboard Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/Ew0knnmuRyg?si=hl6SQiIjdvMuSnoO"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import QuestionBank from './QuestionBank'
import QuizScheduling from './QuizScheduling'
import QuizResponse from './QuizResponse'
import ViewQuestionBank from "./ViewQuestionBank"
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    'question-bank': QuestionBank,
    'quiz-scheduling': QuizScheduling,
    'quiz-response': QuizResponse,
    'view-question-bank': ViewQuestionBank,
    Breadcrumbs
  },
  data() {
    return {
      is_admin: false,
      questionbank: false,
      videoDialog:false,
      scheduling: false,
      response: false,
      viewqb: false,
    };
  },
  methods: {
  }
}
</script>
<style scoped>
</style>